module.exports = __webpack_public_path__ + "img/poweredByControlla.0b397ad4.svg";